import React, { Component } from "react";

export default class PageNotFound extends Component {
  render() {
    return (
      <div className="flex_center" style={{ height: "40vh", fontSize: "20px" }}>
        404! Page Not Found
      </div>
    );
  }
}
